import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-154">
      <Header data-id="element-155" />
      <main className="flex-grow" data-id="element-156">
        <Outlet data-id="element-157" />
      </main>
      <Footer data-id="element-158" />
    </div>;
}